import { CookieService } from '../../tools/CookieService.js';
import { DomHelpers } from '../DomHelpers.js';

/**
 * Акцепт cookies — вешает обработчик на кнопку и скрывает блок после клика.
 */
function acceptCookies(root = document.body) {
    if (CookieService.get('cookie_accepted') !== 'true') {
        const btnCookie = root.querySelector('.cookies_button');
        if (btnCookie) {
            btnCookie.addEventListener('click', () => {
                CookieService.set('cookie_accepted', 'true');
                const cookiesView = btnCookie.closest('[data-key=cookiesView]');
                DomHelpers.hide(cookiesView);
            }, { once: true });
        }
    }
}

export { acceptCookies };
